// Refresh server-side availability and cart exclusions when browser Back restores
// a cached product page. Normal page loads and cart changes use native rendering.
if (!customElements.get('laserlab-upsell')) {
  customElements.define('laserlab-upsell', class extends HTMLElement {
    connectedCallback() {
      this.onPageShow = (event) => {
        if (event.persisted) this.refresh();
      };
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShow);
      this.request?.abort();
    }

    async refresh() {
      this.request?.abort();
      this.request = new AbortController();
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: this.request.signal, cache: 'no-store' });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.getElementById(this.id);
        if (!this.isConnected || !next) return;
        this.innerHTML = next.innerHTML;
        this.hidden = next.hidden;
      } catch (error) {
        // Preserve working links and native product forms if refresh is unavailable.
      }
    }
  });
}
